import { routes as benefitPRoutes } from "./benefit-packages/routes";
export const routes = (prefix) => [
    {
        path: `/${prefix}/organizations/setup`,
        name: `${prefix}.organizations.setup.index`,
        component: () => import('./setup/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.organizations.setup.index`,
                PageDescription: "Organization Listing/Create",
            },
        },
    },
    {
        path: `/${prefix}/organizations/cover-types`,
        name: `${prefix}.organizations.cover-types.index`,
        component: () => import('./cover-types/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.organizations.cover-types.index`,
                PageDescription: "Cover type Listing/Create",
            },
        },
    },
    {
        path: `/${prefix}/organizations/insurance-item-prices`,
        name: `${prefix}.organizations.insurance-item-prices.index`,
        component: () => import('./insurance-items-prices/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.organizations.insurance-item-prices.index`,
                PageDescription: "Insurance Item Prices Listing/ Create",
            },
        },
    },
    ...benefitPRoutes(prefix),
];
